import React, { useEffect, useState } from "react";
import "./AddHotelFormPopUp.scss";
import { useAdmin } from "../../contexts/AdminContext";
import InputBox from "../../components/InputBox";
import Label from "../../components/Label";
import TextArea from "../../components/TextArea";
import CustomButton from "../../components/CustomButton";
import HotelRoomCard from "../HotelRoomCard";
import {
  handleAddHotelApiCall,
  handleGetAllHotelApiCall,
  handleUpdateHotelApiCall,
} from "../../utils/AdminApiCall";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../constants/firebase";
import { v4 } from "uuid";

const formList = [
  {
    id: 1,
    type: "text",
    placeHolder: "Enter hotel name",
    label: "Hotel Name",
    name: "hotelName",
  },
  {
    id: 2,
    type: "text",
    placeHolder: "Enter City",
    label: "City",
    name: "city",
  },
  {
    id: 3,
    type: "text",
    placeHolder: "Enter state",
    label: "State",
    name: "state",
  },
  {
    id: 4,
    type: "text",
    placeHolder: "Enter Country",
    label: "Country",
    name: "country",
  },
  {
    id: 5,
    type: "text",
    placeHolder: "Enter latitude",
    label: "Latitude",
    name: "latitude",
  },
  {
    id: 6,
    type: "text",
    placeHolder: "Enter Longitude",
    label: "Longitude",
    name: "longitude",
  },
  {
    id: 7,
    type: "textarea",
    placeHolder: "Enter Longitude",
    label: "Description",
    name: "description",
  },
];

const rulesForm = [
  {
    id: 1,
    label: "Married",
    name: "married",
  },
  {
    id: 2,
    label: "UnMarried",
    name: "unmarried",
  },
  {
    id: 3,
    label: "Smoking",
    name: "smoking",
  },
  {
    id: 4,
    label: "Drinking",
    name: "drinking",
  },
  {
    id: 5,
    label: "Wifi",
    name: "wifi",
  },
  {
    id: 6,
    label: "Water",
    name: "water",
  },
  {
    id: 7,
    label: "Food",
    name: "food",
  },
  {
    id: 8,
    label: "Electricity",
    name: "electricity",
  },
  {
    id: 9,
    label: "Gym",
    name: "gym",
  },
  {
    id: 10,
    label: "Pets",
    name: "pet",
  },
];
const AddHotelFormPopUp = () => {
  const adminContext = useAdmin();
  const [roomList, setRoomList] = useState([]);
  const [formData, setFormData] = useState({
    hotelName: "",
    city: "",
    state: "",
    country: "",
    description: "",
    latitude: "",
    longitude: "",
    married: false,
    unmarried: false,
    smoking: false,
    drinking: false,
    wifi: false,
    water: false,
    food: false,
    electricity: false,
    gym: false,
    pet: false,
    coverImgUrl: "",
  });
  const [isEdit, setIsEdit] = useState(false);
  const [initialRoomCount, setInitialRoomCount] = useState(0);
  const [image, setImage] = useState(null);
  const handleClose = () => {
    adminContext.handleSetHotelFormPopUp((prevState) => {
      return {
        ...prevState,
        visible: false,
        data: null,
      };
    });
  };

  const handleAddRoom = () => {
    let tempList = [...roomList];
    if (isEdit) {
      tempList.push({
        hotelRoomId: null,
        roomCount: "",
        adultCount: "",
        childrenCount: "",
        price: "",
        airConditioner: false,
      });
    } else {
      tempList.push({
        roomCount: "",
        adultCount: "",
        childrenCount: "",
        price: "",
        airConditioner: false,
      });
    }
    setRoomList(tempList);
  };

  const handleOnChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => {
      return {
        ...prevState,
        [name]:
          type === "text" || type === "textarea"
            ? value
            : type === "checkbox"
            ? checked
            : checked,
      };
    });
  };

  const handleRoomOnChange = (e, index) => {
    const { name, type, checked, value } = e.target;
    let tempList = [...roomList];
    tempList[index][name] = type === "number" ? value : checked;
    setRoomList(tempList);
  };

  const handleDeleteRoom = (index) => {
    let tempList = [...roomList];
    if (isEdit && index + 1 <= initialRoomCount) {
      return;
    }
    tempList = tempList
      .slice(0, index)
      .concat(tempList.slice(index + 1, tempList.length));
    setRoomList(tempList);
  };

  const [imageURL, setImageURL] = useState("");
  const handleSubmit = (e) => {
    let uploadedImageURL = "";
    let dataObj;
    let response;
    if (image) {
      const imageRef = ref(
        storage,
        `ectravel_hotel_images/${image.name + v4()}`
      );
      uploadBytes(imageRef, image).then((res) => {
        getDownloadURL(res.ref).then((url) => {
          uploadedImageURL = url;
          dataObj = {
            ...formData,
            coverImgUrl: uploadedImageURL,
            roomList: [...roomList],
          };
          if (isEdit) {
            response = handleUpdateHotelApiCall(dataObj);
          } else {
            response = handleAddHotelApiCall(dataObj);
          }
          response.then((res) => {
            if (res?.status === 200) {
              alert(res?.data);
              handleClose();
              const response = handleGetAllHotelApiCall();
              response.then((res) => {
                if (res.status === 200) {
                  adminContext.handleSetHotelList(res.data);
                }
              });
            }
          });
        });
      });
    } else {
      dataObj = {
        ...formData,
        roomList: [...roomList],
      };
      if (isEdit) {
        response = handleUpdateHotelApiCall(dataObj);
      } else {
        response = handleAddHotelApiCall(dataObj);
      }
      response.then((res) => {
        if (res?.status === 200) {
          alert(res?.data);
          handleClose();
          const response = handleGetAllHotelApiCall();
          response.then((res) => {
            if (res.status === 200) {
              adminContext.handleSetHotelList(res.data);
            }
          });
        }
      });
    }
    // response.then((res) => {
    //   if (res?.status === 200) {
    //     alert(res?.data);
    //     handleClose();
    //     const response = handleGetAllHotelApiCall();
    //     response.then((res) => {
    //       if (res.status === 200) {
    //         adminContext.handleSetHotelList(res.data);
    //       }
    //     });
    //   }
    // });
  };

  useEffect(() => {
    if (adminContext?.hotelFormPopUp?.data !== null) {
      setIsEdit(true);
      let data = adminContext?.hotelFormPopUp?.data;
      setFormData((prevState) => {
        return {
          ...prevState,
          hotelId: data?.hotelId,
          hotelMediaId: data?.hotelMediaId,
          hotelName: data?.hotelName,
          coverImgUrl: data?.coverImgUrl,
          city: data?.city,
          state: data?.state,
          country: data?.country,
          description: data?.description,
          latitude: data?.latitude,
          longitude: data?.longitude,
          married: data?.married,
          unmarried: data?.unmarried,
          smoking: data?.smoking,
          drinking: data?.drinking,
          wifi: data?.wifi,
          water: data?.water,
          food: data?.food,
          electricity: data?.electricity,
          gym: data?.gym,
          pet: data?.pet,
        };
      });
      setRoomList(data?.roomList);
      setInitialRoomCount(data?.roomList?.length);
    } else {
      setIsEdit(false);
      setFormData({
        hotelName: "",
        coverImgUrl: "",
        city: "",
        state: "",
        country: "",
        description: "",
        latitude: "",
        longitude: "",
        married: false,
        unmarried: false,
        smoking: false,
        drinking: false,
        wifi: false,
        water: false,
        food: false,
        electricity: false,
        gym: false,
        pet: false,
      });
      setRoomList([]);
    }
  }, []);

  const handleImageOnChange = (e) => {
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    setFormData({
      ...formData,
      coverImgUrl: url,
    });
    setImageURL(url);
    setImage(file);
    // const imageRef = ref(storage, `ectravel_hotel_images/${file.name + v4()}`);
    // uploadBytes(imageRef, file).then((res) => {
    //   getDownloadURL(res.ref).then((url) => {});
    // });
  };
  return (
    <div className="AddHotelFormPopUp">
      <div className="hotel-form-container">
        <div className="form-head-container">
          <h3>Add Hotel</h3>
          <span
            className="material-symbols-outlined close-icon"
            onClick={handleClose}
          >
            close
          </span>
        </div>
        <div className="form-content-wrapper">
          <div className="form-content-container">
            <div className="input-box-wrapper">
              <Label value={"Cover Image"} />
              <input type="file" onChange={handleImageOnChange} />
              {formData.coverImgUrl && (
                <img src={formData.coverImgUrl} alt="hotel img" />
              )}
            </div>
            {formList.map((data) => {
              return (
                <div className="input-box-wrapper" key={data.id}>
                  <Label value={data.label} />
                  {data.type === "text" ? (
                    <InputBox
                      type={data.type}
                      placeHolder={data.placeHolder}
                      value={formData[data.name]}
                      name={data.name}
                      onChange={handleOnChange}
                    />
                  ) : data.type === "textarea" ? (
                    <TextArea
                      placeHolder={data.placeHolder}
                      value={formData[data.name]}
                      name={data.name}
                      onChange={handleOnChange}
                    />
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </div>
          <div className="rules-form-container">
            {rulesForm.map((data) => {
              return (
                <div className="input-wrapper" key={data.id}>
                  <Label value={data.label} />
                  <InputBox
                    type="checkbox"
                    checked={formData[data.name]}
                    onChange={handleOnChange}
                    name={data.name}
                  />
                </div>
              );
            })}
          </div>
          <div className="add-room-container">
            <button className="add-room-btn" onClick={handleAddRoom}>
              Add Room
            </button>
            {roomList.map((data, index) => {
              return (
                <HotelRoomCard
                  key={index}
                  index={index}
                  handleDeleteRoom={handleDeleteRoom}
                  state={roomList[index]}
                  handleOnChange={handleRoomOnChange}
                />
              );
            })}
          </div>
        </div>
        <CustomButton
          type="submit"
          value={"Submit"}
          customClassName="submit-btn"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default AddHotelFormPopUp;
